export const PUSHER_ACTIVITY_TIMEOUT_MILLISECONDS = 6000;

export const STORE_STATUS_UPDATED = 'STORE_STATUS_UPDATED';
export const REFRESH_ORDERS_CONTROL = 'REFRESH_ORDERS_CONTROL';
export const REFRESH_APP = 'REFRESH_APP';
export const TEST_ORDER_UPDATE = 'TEST_ORDER_UPDATE';
export const COMPANY_UPDATED = 'COMPANY_UPDATED';

export const ORDER_CREATED = 'ORDER_CREATED';
export const ORDER_UPDATED = 'ORDER_UPDATED';
